import { ContainerPage } from './styles';
import { PageSize, Orientation } from '@react-pdf/types';

interface IRPageProps {
  children?: React.ReactNode | any;
  size?: PageSize;
  orientation?: Orientation;
  wrap?: boolean;
}
export const RPage: React.FC<IRPageProps> = ({
  size = 'A4',
  orientation = 'portrait',
  children,
  wrap,
}) => {
  return (
    <ContainerPage size={size} orientation={orientation} wrap={wrap}>
      {children}
    </ContainerPage>
  );
};
